import script from "./SalesHistory.vue?vue&type=script&setup=true&lang=js"
export * from "./SalesHistory.vue?vue&type=script&setup=true&lang=js"

import "./SalesHistory.vue?vue&type=style&index=0&id=5cf9ab89&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cf9ab89"]])

export default __exports__